<template>
    <div class="page-admin">
        <div class="container">
            <table class="table">
                <tbody>
                    <tr v-for="user in users">
                        <td>{{ user.uid }}</td>
                        <!-- <td>{{ user.data.email }}</td> -->
                        <td>{{ user.data.uid }}</td>
                        <td><button @click="convert(user.uid,user.data)">Converter</button></td>
                    </tr>
                </tbody>
            </table>
            <button @click="convertAllUsers">processar</button>

        </div>
    </div>


</template>
<style>
    .page-admin { padding:40px 0; }
</style>
<script>

    /* eslint-disable no-console */
//import firebase from 'firebase';
import firebase from '@/firebase'
export default {
    data(){
        return {
            db: null,
            users:[],
            authUsers:[
                '1e0eXu010RgVmx7xKklsXEoRIQk2',
                '9v1HUjSKHfh46Mo3M5OWE81sZCq2',
                'B2akzDWseINoFHoFSoKAfDxOeUX2',
                'CzGCpEdaYqdh4LnazGhiDcJb3co1',
                'De8gNV0u7FOCx3IY2eXB7zB7lEq2',
                'FXk49tEKHOSQjLBmbkT79xmctJg2',
                'HY5VOiLNWSNxieYKS5pWCJIevhh2',
                'HqX4vR30ESTW7KAqCI5M9YL59r73',
                'NgqkqKqZfNUrJXGd5HRVyhN15Xj1',
                'PlSeeN6cHUaaEn5CVrEul23cHG62',
                'SGPJjkvQFVd4veIz26wDNATlbrl2',
                'T1Hnl3YIFwNLbDmzACZwTOmt6Ub2',
                'WrWjHFJL3fa2tRxP0tY4STg7YI82',
                'X7kJGd5dzcarn78FUkyMy9um5lx2',
                'XaRhtiddrkdnCUjUcOLb2hi8AD13',
                'Yjyzs8MC24WCRjUTZxabKLCKO653',
                'Yw1nrtRGokablsERzlDPvv0fNjh2',
                'bsAcYpW0xhWgpCNQY98gBkT9zBa2',
                'ciwQejD8yoan0vl88LW41HlY0G33',
                'cm2OLotAARd8przL20WHuL8Eux43',
                'es5S5x2bZGOy3K17k2KRvWou7hJ3',
                'f5m35zJRtxfswoR5YI87th3TlhH2',
                'k2ECtSgqr4XECIP4bjAlswYnNC43',
                'lKGkZ5AfObfeNMJ7ULa3qzgOvYn2',
                'lhUvoWxXugXlfulbjjKLpdpVdiA2',
                'nXEzpj37WIWswGKdo6m8lfDSdR52',
                'suxdY9xP1JbhJbXcmep0GsyRQ2q2',
                'uO8eaGUZj0PRevkDy3pR4qKhVsk2',
                'wODlq80qpnUXON6inQ7vBHtathO2',
                'xUxQkI52oTZszcRM8Cd4PI9wMtx2',
                'z3JZ1VWqaPNeZYY1Xs91fObYWi12',
            ],
        }
    },
    methods: {
        convertAllUsers(){
            var i;
            for(i in this.authUsers){
                var uid = this.authUsers[i];
                var userData = this.users.find(user=>user.uid==uid)
                if(userData){
                    this.convert(uid,userData.data);
                }
            }

        },

        convert(uid,userObject){

            console.log('migrando',uid,userObject.email);
            return;

            var categories = [];
            var links = [];
            var tasks = [];
            var textlinks = [];
            var queue = []

            var oldUserRef = this.db.collection('users').doc(uid);
            queue.push(oldUserRef.collection('categories').get().then(snapshot=>{
                snapshot.forEach(register => {
                    categories.push({uid:register.id,data:register.data()})
                });
            }));
            queue.push(oldUserRef.collection('links').get().then(snapshot=>{
                snapshot.forEach(register => {
                    links.push({uid:register.id,data:register.data()})
                });
            }));
            queue.push(oldUserRef.collection('tasks').get().then(snapshot=>{
                snapshot.forEach(register => {
                    tasks.push({uid:register.id,data:register.data()})
                });
            }));
            queue.push(oldUserRef.collection('textlinks').get().then(snapshot=>{
                snapshot.forEach(register => {
                    textlinks.push({uid:register.id,data:register.data()})
                });
            }));

            Promise.all(queue).then(() => {
                var newUserRef = this.db.collection('users').doc(userObject.email);
                newUserRef.set(userObject).then(()=>{

                    var categoriesRef = newUserRef.collection('categories');
                    var linksRef = newUserRef.collection('links');
                    var tasksRef = newUserRef.collection('tasks');
                    var textlinksRef = newUserRef.collection('textlinks');

                    let batch = this.db.batch();
                    var i;
                    for(i in categories){
                        let catRef = categoriesRef.doc(categories[i].uid);
                        batch.set(catRef, categories[i].data);
                    }
                    for(i in links){
                        let docRef = linksRef.doc(links[i].uid);
                        batch.set(docRef, links[i].data);
                    }
                    for(i in tasks){
                        let docRef = tasksRef.doc(tasks[i].uid);
                        batch.set(docRef, tasks[i].data);
                    }
                    for(i in textlinks){
                        let docRef = textlinksRef.doc(textlinks[i].uid);
                        batch.set(docRef, textlinks[i].data);
                    }

                    batch.commit().then( () => {
                      console.log('Salvou novo usuario '+userObject.email);
                    });

                });
            })


        },
    },
    mounted(){
        this.db = firebase.firestore();

        this.$store.dispatch('startLoading');
        this.db.collection('users').get().then(snapshot => {
          snapshot.forEach(register => {
            this.users.push({uid:register.id,data:register.data()});
          })
          this.$store.dispatch('stopLoading');
        })

    },
}
</script>
